"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TabBar = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Tabs__TabBar",
  componentId: "lpeso1-0"
})(["background-color:", ";display:flex;border-radius:5px 5px 0 0;padding-top:6px;border-bottom:2px solid ", ";"], (0, _themeGet["default"])('colors.neutral.200'), (0, _themeGet["default"])('colors.neutral.300'));
var TabComponent = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Tabs__TabComponent",
  componentId: "lpeso1-1"
})(["background-color:", ";border-radius:5px 5px 0px 0px;color:", ";text-align:center;font-size:24px;padding:8px 16px;margin:0 6px;cursor:pointer;", ";"], (0, _themeGet["default"])('colors.primary.100'), (0, _themeGet["default"])('colors.primary.900'), function (props) {
  return props.active && "\n    color: white;\n    background-color: ".concat((0, _themeGet["default"])('colors.primary.500')(props), ";\n    margin-bottom: -2px;\n  ");
});

var Tabs = function Tabs(_ref) {
  var activeKey = _ref.activeKey,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["activeKey", "children"]);

  var _useState = (0, _react.useState)(activeKey),
      _useState2 = _slicedToArray(_useState, 2),
      currentKey = _useState2[0],
      setCurrentKey = _useState2[1];

  return _react["default"].createElement(_Box["default"], {
    display: "flex",
    width: "100%",
    flexDirection: "column"
  }, _react["default"].createElement(TabBar, null, _react["default"].Children.map(children, function (v) {
    return _react["default"].createElement(TabComponent, {
      active: currentKey === v.props.tabKey,
      onClick: function onClick() {
        return setCurrentKey(v.props.tabKey);
      }
    }, v.props.label || v.props.tabKey);
  })), _react["default"].createElement(_Box["default"], {
    display: "flex",
    width: "100%"
  }, _react["default"].Children.map(children, function (child) {
    return _react["default"].cloneElement(child, {
      active: currentKey === child.props.tabKey
    });
  })));
};

var _default = Tabs;
exports["default"] = _default;